'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ ["$state", "$rootScope", "$stateParams", "ProjectService", "ProjectCookieFactory", "RedirectService", "AuthenticationFactory", "$urlRouter", "$uibModalStack", "$q", "UrlRoutingFactory", "$cookies", "MonitoringStoreService", "ApiTokenManagement", "$interval", "$injector",
function ($state, $rootScope, $stateParams, ProjectService, ProjectCookieFactory, RedirectService, AuthenticationFactory, $urlRouter, $uibModalStack, $q, UrlRoutingFactory, $cookies, MonitoringStoreService, ApiTokenManagement, $interval, $injector) {
    var factory = {};
    var checkTokenExpiryInterval = undefined;
    var checkTokenPeriod = 15000; // every 15 seconds

    /**
     * if you ever need to modify this: RIP †
     *
     * This function controls the flow of the state changes.
     *
     * Scenario 1: the user is logged in
     *  Scenario 1.1: the user is going the a url that contains a projectId
     *                >> we extract the projectId from the URL and let it propagate to the other components
     *  Scenario 1.2: the user is going to a url without a projectId
     *                >> if there is no selected project yet
     *                  >> we try to get the projectId out of the cookie (this is not tab-specific)
     *                    >> if the cookie doesn't exist, select default
     * Scenario 2: the user is not logged in
     *
     */

    $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams, options) => {
        
        $rootScope.$emit('menu-changed', toParams.projectId);
        $injector.get('menuBehaviorSubjectService').inform('menu-changed', toParams.projectId);

    })

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        var toStateName = toState.name;
        var integratedConsole = $cookies.get('nomad.noc.ng.integratedConsole');

        if (integratedConsole === "true") {
            if (toStateName === 'monitoring' || toStateName === 'monitoring.alarms' || toStateName === 'monitoring.tiles' || toStateName === 'monitoring.map' || toStateName === 'monitoring.table'
             )  {
                if (toParams.projectId !== "0") {
                    event.preventDefault();
                    $state.go(toStateName , {
                        "projectId": 0
                    }); 
                }
            } 
            else {
                if (toParams.projectId === "0") {
                    var projectId = $cookies.get('nomad.noc.ng.defaultProjectId');
                    event.preventDefault();
                    setTimeout(() => $state.go(toStateName , {"projectId": projectId}, { reload: true }), 0);
                }

            }
        }

        if((fromState.name === 'monitoring-detail') && (toState.name === 'monitoring-detail') && (toParams.projectId !== fromParams.projectId)) {
            event.preventDefault();
            setTimeout(() => $state.go('monitoring' , {
                "projectId": toParams.projectId
            }), 0); 
        }

        if((fromState.name.includes('period-analysis')) && (toState.name.includes('period-analysis')) && (toParams.projectId !== fromParams.projectId)) {
            event.preventDefault();
            setTimeout(() => $state.go('period.search' , {
                "projectId": toParams.projectId
            }), 0); 
        }

        if((fromState.name.includes('trip-analysis')) && (toState.name.includes('trip-analysis')) && (toParams.projectId !== fromParams.projectId)) {
            event.preventDefault();
            setTimeout(() => $state.go('trip.search' , {
                "projectId": toParams.projectId
            }), 0); 
        }



        if((fromState.name.includes('trip-dashboard')) && (toState.name.includes('trip-dashboard')) && (toParams.projectId !== fromParams.projectId)) {
            // event.preventDefault();
            setTimeout(() => $state.go('trip-dashboard' , {
                "projectId": toParams.projectId
            }, { reload: false, inherit: false }), 0); 
        }


        var validProjects = MonitoringStoreService.getProjects();
        if (toParams.projectId === "" && validProjects && validProjects.length > 0) {
            
            var defaultValidProject = validProjects.filter(project => project.id > 0)[0];
            var existingDefaultId = $cookies.get('nomad.noc.ng.defaultProjectId');
            var projectId = validProjects.find(project => project.id == existingDefaultId) ? existingDefaultId : defaultValidProject.id;
            event.preventDefault();
            $state.go(toStateName , {"projectId": projectId});
        }
       
        $rootScope.title = toState.title;
        RedirectService.setPreviousState(fromState, fromParams);
        closeModalWindow();
        if (currentlyLoggedIn()) {
            // we aren't allowed to go to certain pages after we are logged in (eg. /login)
            // so we prevent the user from visiting those pages by preventing the event, and redirecting them to home
            if (shouldPreventPage(toState.name)) {
                preventLoginPageAccess(event);
                checkTokenExpiryInterval = undefined;
            } else {
                // if this is the first time the application runs (eg. new tab, cleared chache,..)
                // we need to make sure we have the projects ready
                if (ProjectService.projectsLoaded()) {
                    // we always have to extract the selected projectId from the url (if defined)
                    // if a projectId is found, we propagate this to all subscribers of ProjectService
                    if (containsProjectStateParam(toParams)) {
                        setProjectIdFromURL(toParams.projectId);
                    }
                } else {
                    // if there are no projects yet, we must fetch them first
                    // then we extract the projectId from the components in the following priority: url, cookie, default value
                    initializeProjectServiceState(toState, toParams);
                }

                if (!isAuthorized(toState.name, toParams.projectId)) {
                    console.error("prevented access to:" + toState.name);
                    preventLoginPageAccess(event);
                } else {
                    tokenValidityChecking();
                }
            }
        } else {
            // if the user is not logged in, nor pressed to logout button
            if (!AuthenticationFactory.isLoggingOut()) {
                var token = ApiTokenManagement.getToken();
                // check if the cookie exists, if so update user information (this acts the same as logging in)
                var user = AuthenticationFactory.loginFromCookie();
                if (user && token) {
                    // the user was defined in the cookie, the user is now logged in
                    // proceed to extract the project id from url-cookie-default

                    initializeProjectServiceState(toState, toParams);

                    if (!util.isDefined(ProjectService.getSelectedProjectId())) {
                        event.preventDefault();
                        ProjectService.subscribe("AUTHORIZATION", function () {
                            if (isAuthorized(toState.name, toParams.projectId) && !shouldPreventPage(toState.name)) {
                                $urlRouter.sync(); // make sure we have a projectId before we proceed.
                                tokenValidityChecking()
              
                            } else {
                                preventLoginPageAccess(event);
                            }
                            ProjectService.unsubscribe("AUTHORIZATION");
                        });
                    } else {
                        if (!isAuthorized(toState.name, toParams.projectId)) {
                            preventLoginPageAccess(event);
                            checkTokenExpiryInterval = undefined;
                        } 
                    }

                    // we didn't find a c00kie :(
                } else {
                    // if we're not going to the login or the password reset page, remember the page, then goto login
                    if (toState.name !== 'login' && toState.name !== "password-reset") {
                        gotoInitialLoginpage(event, toState.name, toParams);
                    }
                }
            } else {
                checkTokenExpiryInterval = undefined;
            }
        }
    });

    var tokenValidityChecking = () => {
        if (!checkTokenExpiryInterval) {
            checkTokenExpiryInterval = $interval(() => {
                if ($state.current && $state.current.url === '/login') {
                    checkTokenExpiryInterval = undefined;
                } else {
                    if (AuthenticationFactory.checkTokenExpiry()) {
                        AuthenticationFactory.logout(true);
                    }
                }
              }, checkTokenPeriod);
        }
    }

    var closeModalWindow = function () {
        var top = $uibModalStack.getTop();
        if (top) {
            $uibModalStack.dismiss(top.key);
        }
    };

    /**
     * Fetches the projects.
     * Extracts and propagates the projectId from either the url, cookie or default value
     * @param toState
     * @param toParams
     */
    var initializeProjectServiceState = function (toState, toParams) {
        ProjectService.fetchProjects().then(function (projects) {
            MonitoringStoreService.setProjects(projects);
            ProjectCookieFactory.setIntegratedConsoleStatus(projects);
            if (toParams && toParams.projectId) {
                // set projectId from the url
                setProjectIdFromURL(toParams.projectId);
            } else if (ProjectCookieFactory.hasCookie()) {
                // set projectId from the cookie
                ProjectCookieFactory.propagateProjectId();
            } else {
                // set a default projectId
                ProjectService.setDefaultProject();

                if (projects && projects.length > 0) {
                    if (ProjectCookieFactory.isIntegratedConsole()) {
                        var existingProjectId = ProjectCookieFactory.getProjectId();
                        if (existingProjectId) {
                            ProjectCookieFactory.setProjectId(existingProjectId);
                        } else {
                            var defaultProject = ProjectCookieFactory.getDefaultProjectId();
                            ProjectCookieFactory.setProjectId(defaultProject || projects[1].id);
                        }
                        
                    } else {
                        ProjectCookieFactory.setProjectId(projects[0].id);
                    }

                }
            }
        });
    };

    /**
     * Forces the user to login, keeps track of the previous page to redirect afterwards
     * @param event
     * @param redirectPage      state name
     * @param redirectParams    state parameters
     */
    var gotoInitialLoginpage = function (event, redirectPage, redirectParams) {
        RedirectService.setRedirectPage(redirectPage, redirectParams);
        event.preventDefault();
        RedirectService.gotoLoginPage(true);
    };

    /**
     * Returns true if the user shouldn't be allowed to enter the page
     * @param pagename      name of the state
     * @returns {*|boolean}
     */
    var shouldPreventPage = function (pagename) {
        var preventPages = ["login", "index"];

        return arrayUtil.contains(preventPages, pagename);
    };

    /**
     * Prevent the user from accessing the requested page, goto home instead
     * @param event
     */
    var preventLoginPageAccess = function (event) {
        console.warn("prevented from accessing page");
        event.preventDefault();
        if(util.isDefined(ProjectService.getSelectedProjectId())){
            $state.go('home', {projectId: ProjectService.getSelectedProjectId()}, {location: "replace"});
        }else{
            AuthenticationFactory.logout();
            $state.go('index');
        }
    };

    /**
     * This function gets called after the user pressed the login button & is successfully authenticated
     * It will redirect to either the redirectPage or to the home page
     */
    factory.proceedOnLogin = function () {
        // there is a redirect page, so just redirect to it
        if (util.isDefined(RedirectService.getRedirectPage())) {
            RedirectService.gotoCurrentRedirectPath();
        } else {
            // there is no redirect page, we want to go to home with a projectId
            ProjectService.fetchProjects().then(function (projects) {
                ProjectCookieFactory.setIntegratedConsoleStatus(projects);
                // the state.go must be called when the projectId is finally set in the projectService
                ProjectService.subscribe("LOGIN", function (projectId) {
                    $state.go('home', {projectId: projectId}, {location: "replace"});
                    ProjectService.unsubscribe("LOGIN");
                });

                if (ProjectCookieFactory.hasCookie()) {
                    // set projectId from the cookie
                    ProjectCookieFactory.propagateProjectId();
                } else {
                    // set a default projectId
                    ProjectService.setDefaultProject();
                    if (ProjectCookieFactory.isIntegratedConsole()) {
                        var existingProjectId = ProjectCookieFactory.getProjectId();
                        if (existingProjectId) {
                            ProjectCookieFactory.setProjectId(existingProjectId);
                        } else {
                            ProjectCookieFactory.setProjectId(projects[1].id);
                        }
                    } else {
                        ProjectCookieFactory.setProjectId(projects[0].id);
                    }
                }
            });
        }
    };

    /**
     * Sets the selected project with callerId URL
     * @param projectId     the projectId
     * @returns the projectId, if any
     */
    var setProjectIdFromURL = function (projectId) {
        if (util.isDefined(projectId)) {
            ProjectService.setSelectedProjectById(projectId, "URL");
            // $rootScope.$emit('trains-updated');
            return projectId;
        } 
        return null;
    };

    /**
     * Return true if the user is logged in
     * @returns {*|boolean}
     */
    var currentlyLoggedIn = function () {
        // loggingOut becomes true when the user is in the process of logging out
        // if the user is defined, and not in the logout process, he is logged in
        //Change for NMS-206
       return (!AuthenticationFactory.checkTokenExpiry() && !AuthenticationFactory.isLoggingOut() && AuthenticationFactory.getUser() && AuthenticationFactory.getUser().token );
    };

    /**
     * Returns true if the stateParams contains a projectId
     * @returns {boolean}
     */
    var containsProjectStateParam = function (toParams) {
        return util.isDefined($stateParams.projectId) || (util.isDefined(toParams) && util.isDefined(toParams.projectId));
    };

    /**
     * Changes the current url (if needed) to include the new selected project id
     * @param id    selected project id
     */
    var propagateToURL = function (id) {
        if (containsProjectStateParam()) {
            // inject projectId into url
            $stateParams.projectId = id;
            var urlParams = UrlRoutingFactory.getCurrentParameters();

            for (var property in urlParams) {
                if (urlParams.hasOwnProperty(property)) {
                    $stateParams[property] = urlParams[property];
                }
            }
            $state.go($state.current.name, $stateParams);
        }
    };

    // subscribe this service to the projectService with callerId "URL"
    ProjectService.subscribe("URL", propagateToURL);

    /**
     * Redirects to 404 and resets projectId to a default value when triggered
     * @param message   message to print
     */
    var projectServiceErrorHandler = function (message) {
        console.warn(message);
        $state.go("error", {error: "404"}, {location: "replace"});
        ProjectService.setDefaultProject("URL"); // set a default project with callerId "URL" so we don't trigger an url change
    };

    var isAuthorized = function (stateName, projectId) {
        "use strict";
        //TODO NMS-2624 Temp fix
        if (AuthenticationFactory.isAdmin() || projectId === "0") {
            return true;
        } else if (stateName !== "home" && stateName !== "password-reset") {
            var user = AuthenticationFactory.getUser();
            var pages = user && user.projectPageSet && user.projectPageSet[projectId || ProjectService.getSelectedProjectId()];

            if (!util.isDefined(pages)) {
                return false;noc
            }

            return pages.includes(stateName);
        } else {
            return true;
        }
    };

    ProjectService.subscribeErrorHandler("ERRORHANDLER", projectServiceErrorHandler);
    return factory;
}];